import React from 'react';

import { DocumentSpecifiqueDtoUtilisateurDestinataireEnum } from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseUploader, {
  uploaderFullWidthColProps,
} from 'components/BaseForm/BaseUploader';
import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { CSSUtils } from 'utils/CSSUtils';
import { typeUtilisateurDestinataireMapping } from 'utils/enumData';

import { fileTypes, maxFileSize } from './utils/constants';
import {
  useSubmitUploadDocumentSpecifique,
  useValidateUploadDocumentSpecifique,
} from './utils/hooks';
import {
  DocumentSpecifiqueFormField,
  DocumentSpecifiqueFormFieldEnumType,
  DocumentSpecifiqueFormValue,
} from './utils/type';

interface FormCreateProps {
  close: () => void;
  onSuccess: (lastModificationDate: number) => void;
}

export default function FormCreate({
  close,
  onSuccess,
}: FormCreateProps): React.ReactElement {
  const initials: DocumentSpecifiqueFormValue = {};

  const { submit, inProgress } = useSubmitUploadDocumentSpecifique(
    close,
    onSuccess,
  );
  const validateField = useValidateUploadDocumentSpecifique();

  return (
    <>
      <h3>Partager un document</h3>
      <BaseForm<
        DocumentSpecifiqueFormValue,
        DocumentSpecifiqueFormFieldEnumType
      >
        onSubmit={submit}
        onCancel={close}
        isSubmitting={inProgress}
        initialValues={initials}
        labelCol={{ span: CSSUtils.LlargeWrapperCol }}
        wrapperCol={{ span: CSSUtils.mediumLargeWrapperCol }}
        validateField={validateField}
        inputs={[
          {
            field: DocumentSpecifiqueFormField.NAME,
            required: true,
            name: 'nomDocument',
            label: 'Nom du fichier',
            dependencies: ['utilisateursDestinataires'],
          },
          {
            field: DocumentSpecifiqueFormField.TYPE_DESTINATAIRE,
            required: true,
            name: 'utilisateursDestinataires',
            label: 'Destinataire(s)',
            render: () => {
              return (
                <BaseSelect
                  mode="multiple"
                  options={Object.values(
                    DocumentSpecifiqueDtoUtilisateurDestinataireEnum,
                  )}
                  getOptionValue={(
                    option: DocumentSpecifiqueDtoUtilisateurDestinataireEnum,
                  ) => option}
                  getOptionLabel={(
                    option: DocumentSpecifiqueDtoUtilisateurDestinataireEnum,
                  ) => typeUtilisateurDestinataireMapping[option]}
                />
              );
            },
          },
          {
            field: DocumentSpecifiqueFormField.FILE,
            name: 'file',
            label: 'File',
            ...uploaderFullWidthColProps,
            render: () => {
              return (
                <BaseUploader
                  acceptedFilesTypes={fileTypes.split(',')}
                  maxFileSize={+maxFileSize}
                />
              );
            },
          },
        ]}
        renderButtonAction={(Submit, Cancel) => {
          return (
            <div className="UploadPieceJointeActions">
              {Cancel}
              {Submit}
            </div>
          );
        }}
      />
    </>
  );
}
